export function isIosDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/** @returns {'chrome'|'other'|'safari'|null} */
export function iosBrowser() {
  if (!isIosDevice()) return null;
  const ua = navigator.userAgent || '';
  if (/CriOS/i.test(ua)) return 'chrome';
  if (/FxiOS|EdgiOS|OPiOS|DuckDuckGo/i.test(ua)) return 'other';
  return 'safari';
}

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  return (
    window.navigator.standalone === true ||
    (typeof window.matchMedia === 'function' &&
      window.matchMedia('(display-mode: standalone)').matches)
  );
}
